<template>
  <div class="nc-form-field" :class="{ 'nc-form-field--error': !!error }">
    <label v-if="label" class="nc-form-field__label" :for="forId">
      {{ label }}
      <span v-if="required" class="nc-form-field__required" aria-hidden="true">*</span>
    </label>
    <div class="nc-form-field__control">
      <slot />
    </div>
    <p v-if="error" class="nc-form-field__error">{{ error }}</p>
    <p v-else-if="hint" class="nc-form-field__hint">{{ hint }}</p>
  </div>
</template>

<script>
export default {
  name: 'NcFormField',
  props: {
    label: { type: String, default: '' },
    hint: { type: String, default: '' },
    error: { type: String, default: '' },
    required: { type: Boolean, default: false },
    forId: { type: String, default: undefined },
  },
};
</script>

<style scoped>
.nc-form-field {
  padding: 8px 16px;
}
.nc-form-field__label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: var(--nc-text, #1a1a2e);
  margin-bottom: 6px;
}
.nc-form-field__required {
  color: var(--nc-color-danger, #e74c3c);
  margin-left: 2px;
}
.nc-form-field__hint {
  margin: 6px 0 0;
  font-size: 12px;
  color: var(--nc-text-secondary, #92949c);
}
.nc-form-field__error {
  margin: 6px 0 0;
  font-size: 12px;
  color: var(--nc-color-danger, #e74c3c);
}
.nc-form-field--error .nc-form-field__label {
  color: var(--nc-color-danger, #e74c3c);
}
</style>
